$(document).ready(function () {
  let platform = navigator.platform;
  let mtp = navigator.maxTouchPoints;

  // set mtp to 5 to test iPad behaviour on desktop
  // mtp = 5;

  if (platform === 'MacIntel' && mtp > 1) {
    document.getElementById('iPad-show').classList.remove('hidden')
    document.getElementById('iPad-hide').classList.add('hidden')
    document.getElementById('iPad-hide2').classList.remove('md:block')
  }
});
